const testimonials = [
  {
    name: "Jennifer T.",
    location: "Gainesville, GA",
    rating: 5,
    text: "We had a family cruise to the Caribbean in 10 days and my son's passport had expired. I didn't know where to start. Fast Passport Center sent me a perfect checklist, told me exactly which clerk to visit in Gainesville, and handled the rest. We had his passport in 8 days. Lifesavers!",
    service: "Child Passport",
  },
  {
    name: "Robert M.",
    location: "Flowery Branch, GA",
    rating: 5,
    text: "I had a last-minute business trip to Japan and realized my passport was expired the day before. Fast Passport Center got me an emergency passport in 3 days. I shipped from the UPS Store in Gainesville overnight — never had to drive to Atlanta once. Incredible service.",
    service: "Emergency Passport",
  },
  {
    name: "Lisa K.",
    location: "Buford, GA",
    rating: 5,
    text: "My passport was damaged in a flood at our house in Buford. I was sure I'd miss my vacation. Fast Passport Center walked me through the replacement process, reviewed my documents, and got my new passport processed in 7 days. Couldn't be happier.",
    service: "Damaged Passport Replacement",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function GainesvilleTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Gainesville Travelers Say About Our Expedited Passport Service
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from real travelers across Gainesville, Flowery Branch, Buford, and northeast Georgia who trusted Fast Passport Center with their emergency and expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}